import { useEffect, useState } from 'react'

const useDebouncedValue = <T>(value: T, delay: number) => {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay)
        return () => clearTimeout(timer)
    }, [value, delay])

    return debounced
}

export default useDebouncedValue
